import React, { useState } from 'react';

const SERVICES_DETAILED = [
    {
        id: 1,
        icon: '💻',
        title: 'Développement Web',
        description: 'Applications web modernes et performantes',
        features: ['React.js', 'Node.js', 'TypeScript', 'Responsive Design', 'LMS'],
        fullDesc: 'Nous créons des applications web haute performance avec les dernières technologies. De la conception à la mise en production, nous gérons chaque étape pour vous offrir une solution robuste et scalable.',
        details: [
            'Sites web responsifs',
            'Applications SPA (Single Page Applications)',
            'Progressive Web Apps (PWA)',
            'Optimisation SEO',
            'Performance maximale'
        ]
    },
    {
        id: 2,
        icon: '📱',
        title: 'Applications Mobiles',
        description: 'Solutions mobiles natives et cross-platform',
        features: ['React Native', 'Flutter', 'Ionic', 'Cordova', 'iOS', 'Android'],
        fullDesc: 'Développez vos applications mobiles avec nos experts. Nous créons des apps natives et cross-platform pour atteindre tous vos utilisateurs sur iOS et Android.',
        details: [
            'Applications natives iOS/Android',
            'Applications React Native',
            'Design UX/UI moderne',
            'Intégration API',
            'App Store & Play Store'
        ]
    },
    {
        id: 3,
        icon: '☁️',
        title: 'Architecture Cloud',
        description: 'Infra cloud scalable et sécurisée',
        features: ['AWS', 'DevOps', 'VPS'],
        fullDesc: 'Migrez vers le cloud et bénéficiez d\'une infrastructure scalable, sécurisée et économique. Nous gérons AWS, Azure et Google Cloud pour optimiser vos ressources.',
        details: [
            'Migration cloud complète',
            'Architecture microservices',
            'Load balancing',
            'Auto-scaling',
            'Backup & Disaster Recovery'
        ]
    },
    {
        id: 4,
        icon: '🔒',
        title: 'Cybersécurité',
        description: 'Protection contre les menaces digitales',
        features: ['Pentesting', 'Audit Sécurité', 'Compliance', 'Incident Response'],
        fullDesc: 'Protégez vos données et systèmes avec nos solutions de cybersécurité. Audits, pentests, conformité RGPD et réponse aux incidents inclus.',
        details: [
            'Tests de pénétration',
            'Audits de sécurité',
            'Compliance RGPD',
            'Gestion des accès',
            'Monitoring 24/7'
        ]
    },
    {
        id: 5,
        icon: '🤖',
        title: 'Intelligence Artificielle',
        description: 'Solutions IA et machine learning',
        features: ['AI Gen', 'CNN', 'Computer Vision', 'Chatbots'],
        fullDesc: 'Exploitez la puissance de l\'IA pour automatiser vos processus et créer des expériences personnalisées. De la prédiction au NLP, nous avons l\'expertise.',
        details: [
            'Machine Learning Models',
            'Natural Language Processing',
            'Computer Vision',
            'Chatbots IA',
            'Recommandations personnalisées'
        ]
    },
    {
        id: 6,
        icon: '🚀',
        title: 'DevOps & CI/CD',
        description: 'Automation et deployment continu',
        features: ['Docker', 'Jenkins', 'SonarQube'],
        fullDesc: 'Automatisez votre pipeline de développement avec DevOps. Déploiements continus, monitoring et scaling automatique pour vos applications.',
        details: [
            'Pipeline CI/CD',
            'Containerization Docker',
            'Orchestration Kubernetes',
            'Infrastructure as Code',
            'Monitoring et logging'
        ]
    }
];

export default function Services() {
    const [selectedService, setSelectedService] = useState(null);

    return (
        <div className="services-page">
            <div className="container" style={{ paddingTop: '120px', minHeight: '100vh', paddingBottom: '4rem' }}>
                <div className="section-header">
                    <h1 style={{ fontSize: '3rem', marginBottom: '2rem' }}>Nos Services</h1>
                    <p style={{ fontSize: '1.2rem', color: '#9ca3af', maxWidth: '600px', margin: '0 auto' }}>
                        Une gamme complète de solutions technologiques adaptées à vos besoins
                    </p>
                </div>

                {/* Grille Services */}
                <div style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))',
                    gap: '2rem',
                    marginBottom: '4rem'
                }}>
                    {SERVICES_DETAILED.map(service => (
                        <div
                            key={service.id}
                            style={{
                                background: 'rgba(255, 255, 255, 0.05)',
                                border: '1px solid rgba(97, 218, 251, 0.1)',
                                borderRadius: '10px',
                                padding: '2rem',
                                transition: 'all 0.3s ease',
                                cursor: 'pointer'
                            }}
                            onClick={() => setSelectedService(selectedService === service.id ? null : service.id)}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.borderColor = '#ff7e5f';
                                e.currentTarget.style.transform = 'translateY(-5px)';
                                e.currentTarget.style.background = 'rgba(255, 126, 95, 0.05)';
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.borderColor = 'rgba(97, 218, 251, 0.1)';
                                e.currentTarget.style.transform = 'translateY(0)';
                                e.currentTarget.style.background = 'rgba(255, 255, 255, 0.05)';
                            }}
                        >
                            <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>{service.icon}</div>
                            <h3 style={{ fontSize: '1.3rem', marginBottom: '0.75rem', color: '#fff' }}>
                                {service.title}
                            </h3>
                            <p style={{ color: '#9ca3af', marginBottom: '1.5rem', lineHeight: '1.6' }}>
                                {service.description}
                            </p>
                            <div style={{
                                display: 'flex',
                                flexWrap: 'wrap',
                                gap: '0.5rem'
                            }}>
                                {service.features.map((feature, idx) => (
                                    <span
                                        key={idx}
                                        style={{
                                            background: 'rgba(97, 218, 251, 0.1)',
                                            color: '#61DAFB',
                                            padding: '0.25rem 0.75rem',
                                            borderRadius: '20px',
                                            fontSize: '0.8rem',
                                            border: '1px solid rgba(97, 218, 251, 0.2)'
                                        }}
                                    >
                    {feature}
                  </span>
                                ))}
                            </div>
                            {selectedService === service.id && (
                                <div style={{ marginTop: '1.5rem', paddingTop: '1.5rem', borderTop: '1px solid rgba(97, 218, 251, 0.1)' }}>
                                    <p style={{ color: '#d1d5db', marginBottom: '1rem', lineHeight: '1.6' }}>
                                        {service.fullDesc}
                                    </p>
                                    <h4 style={{ color: '#ff7e5f', marginBottom: '0.75rem' }}>Ce qui est inclus :</h4>
                                    <ul style={{ listStyle: 'none', paddingLeft: 0 }}>
                                        {service.details.map((detail, idx) => (
                                            <li key={idx} style={{ marginBottom: '0.5rem', paddingLeft: '1.5rem', position: 'relative', color: '#9ca3af' }}>
                                                <span style={{ position: 'absolute', left: 0, color: '#ff7e5f' }}>✓</span>
                                                {detail}
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            )}
                        </div>
                    ))}
                </div>

                {/* Section Avantages */}
                <div style={{
                    maxWidth: '900px',
                    margin: '0 auto',
                    padding: '3rem',
                    background: 'rgba(255, 126, 95, 0.05)',
                    border: '1px solid rgba(255, 126, 95, 0.2)',
                    borderRadius: '10px'
                }}>
                    <h2 style={{ fontSize: '1.8rem', marginBottom: '1rem', color: '#ff7e5f' }}>
                        Pourquoi nous choisir ?
                    </h2>
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '2rem', marginTop: '2rem' }}>
                        <div>
                            <h3 style={{ color: '#fff', marginBottom: '0.75rem' }}>Expertise Reconnue</h3>
                            <p style={{ color: '#9ca3af' }}>Plus de 5 ans d'expérience dans les technologies web et mobiles. Nos experts maîtrisent les derniers frameworks et outils du marché.</p>
                        </div>
                        <div>
                            <h3 style={{ color: '#fff', marginBottom: '0.75rem' }}>Qualité Garantie</h3>
                            <p style={{ color: '#9ca3af' }}>Code propre, testé et documenté. Nous suivons les meilleures pratiques et standards de l'industrie pour assurer la qualité.</p>
                        </div>
                        <div>
                            <h3 style={{ color: '#fff', marginBottom: '0.75rem' }}>Support Continu</h3>
                            <p style={{ color: '#9ca3af' }}>Maintenance, mises à jour et support 24/7 après le lancement. Votre succès est notre priorité.</p>
                        </div>
                        <div>
                            <h3 style={{ color: '#fff', marginBottom: '0.75rem' }}>Agile & Flexible</h3>
                            <p style={{ color: '#9ca3af' }}>Méthodologie agile pour s'adapter à vos besoins changeants. Livraisons régulières et feedback constant.</p>
                        </div>
                        <div>
                            <h3 style={{ color: '#fff', marginBottom: '0.75rem' }}>Sécurité Maximale</h3>
                            <p style={{ color: '#9ca3af' }}>Conformité RGPD, chiffrement des données, tests de sécurité réguliers. Vos données sont entre de bonnes mains.</p>
                        </div>
                        <div>
                            <h3 style={{ color: '#fff', marginBottom: '0.75rem' }}>Prix Compétitif</h3>
                            <p style={{ color: '#9ca3af' }}>Tarification transparente sans frais cachés. Nous offrons le meilleur rapport qualité/prix du marché.</p>
                        </div>
                    </div>
                </div>

                {/* Section Process */}
                <div style={{ marginTop: '4rem', textAlign: 'center' }}>
                    <h2 style={{ fontSize: '2.5rem', marginBottom: '3rem', color: '#fff' }}>Notre Processus</h2>
                    <div style={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
                        gap: '2rem',
                        maxWidth: '1000px',
                        margin: '0 auto'
                    }}>
                        {[
                            { num: '01', title: 'Découverte', desc: 'Nous comprenons vos besoins et vos objectifs' },
                            { num: '02', title: 'Conception', desc: 'Création d\'une architecture et d\'un design optimisés' },
                            { num: '03', title: 'Développement', desc: 'Développement agile avec délivrables réguliers' },
                            { num: '04', title: 'Testing', desc: 'Tests exhaustifs pour garantir la qualité' },
                            { num: '05', title: 'Lancement', desc: 'Déploiement en production et formation' },
                            { num: '06', title: 'Support', desc: 'Maintenance continue et améliorations' }
                        ].map((step, idx) => (
                            <div
                                key={idx}
                                style={{
                                    background: 'rgba(255, 255, 255, 0.05)',
                                    border: '1px solid rgba(97, 218, 251, 0.1)',
                                    padding: '2rem',
                                    borderRadius: '10px',
                                    transition: 'all 0.3s ease'
                                }}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.borderColor = '#ff7e5f';
                                    e.currentTarget.style.transform = 'translateY(-5px)';
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.borderColor = 'rgba(97, 218, 251, 0.1)';
                                    e.currentTarget.style.transform = 'translateY(0)';
                                }}
                            >
                                <div style={{
                                    fontSize: '2.5rem',
                                    fontWeight: 'bold',
                                    color: '#ff7e5f',
                                    marginBottom: '0.5rem'
                                }}>
                                    {step.num}
                                </div>
                                <h3 style={{ color: '#fff', marginBottom: '0.5rem' }}>{step.title}</h3>
                                <p style={{ color: '#9ca3af', fontSize: '0.9rem' }}>{step.desc}</p>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Section CTA */}
                <div style={{
                    marginTop: '4rem',
                    padding: '3rem',
                    background: 'linear-gradient(135deg, rgba(255, 126, 95, 0.1) 0%, rgba(97, 218, 251, 0.1) 100%)',
                    borderRadius: '10px',
                    textAlign: 'center',
                    border: '1px solid rgba(255, 126, 95, 0.2)'
                }}>
                    <h2 style={{ fontSize: '2rem', marginBottom: '1rem', color: '#fff' }}>Prêt à démarrer ?</h2>
                    <p style={{ fontSize: '1.1rem', color: '#9ca3af', marginBottom: '2rem' }}>
                        Contactez-nous pour une consultation gratuite et découvrez comment nous pouvons transformer votre entreprise.
                    </p>
                    <a
                        href="/contact"
                        style={{
                            background: '#ff7e5f',
                            color: '#fff',
                            padding: '0.875rem 1.75rem',
                            borderRadius: '6px',
                            textDecoration: 'none',
                            fontWeight: '600',
                            display: 'inline-block',
                            transition: 'all 0.3s ease'
                        }}
                        onMouseEnter={(e) => {
                            e.target.style.background = '#ff6a48';
                            e.target.style.transform = 'translateY(-2px)';
                        }}
                        onMouseLeave={(e) => {
                            e.target.style.background = '#ff7e5f';
                            e.target.style.transform = 'translateY(0)';
                        }}
                    >
                        Demander une consultation
                    </a>
                </div>
            </div>
        </div>
    );
}